<template>
  <div class="design-wrapper">
    <button type="button" class="btn btn-primary" @click="addNewScene">新增场景</button>
    <button type="button" class="btn btn-primary" @click="addNewHotSpot">新增热点</button>
    <button type="button" class="btn btn-primary" @click="addNewRadar">新增雷达</button>
    <form v-show="showItem === 'scene'">
      <div class="form-group">
        <label for="scene-name">场景标识(英文字母和数字，需唯一)</label>
        <input type="text" v-model.trim="sceneData.name" class="form-control" id="scene-name" style="margin-bottom:10px;">
        <button type="button" class="btn btn-primary" @click="queryScene">查询</button>
        <button type="button" class="btn btn-primary" @click="getCurrentScene">获取当前场景</button>
      </div>
      <div class="form-group">
        <label for="scene-title">场景名称(中文)</label>
        <input type="text" v-model.trim="sceneData.title" class="form-control" id="scene-title">
      </div>
      <div class="form-group">
        <label for="scene-title-en">场景名称(英文)</label>
        <input type="text" v-model.trim="sceneData.titleEn" class="form-control" id="scene-title-en">
      </div>
      <div class="form-group">
        <label for="scene-img">场景图片</label>
        <select class="form-control" v-model="sceneData.img" id="scene-img">
          <option v-for="(img, index) of selectImgs" :key="index" :value="img">{{img}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="scene-num">场景排序</label>
        <input type="number" v-model.number="sceneData.index" class="form-control" id="scene-num">
      </div>
      <div class="form-group">
        <label for="scene-h">h</label>
        <input type="number" v-model.number="sceneData.h" class="form-control" id="scene-h">
      </div>
      <div class="form-group">
        <label for="scene-v">v</label>
        <input type="number" v-model.number="sceneData.v" class="form-control" id="scene-v">
      </div>
      <div class="form-group">
        <label for="scene-fov">fov</label>
        <input type="number" v-model.number="sceneData.fov" class="form-control" id="scene-fov">
      </div>
      <div v-if="hotList.length > 0" class="form-group">
        <label>场景热区</label><br />
        <div v-for="hot of hotList" :key="hot" class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" :id="hot" :checked="sceneData.hotspot.indexOf(hot) >= 0" @change="(e) => doSelectHot(e, hot)">
          <label class="form-check-label" :for="hot">{{hot}}</label>
        </div>
      </div>
      <div class="form-group">
        <label for="scene-radar">场景雷达</label>
        <input type="text" v-model.trim="sceneData.radar" class="form-control" id="scene-radar">
      </div>
    </form>
    <!-- hotSpot -->
    <form v-show="showItem === 'hotSpot'">
      <div class="form-group">
        <label for="hot-name">热点标识(英文)</label>
        <input type="text" style="width: 80%; display: inline-block; margin-right: 10px;" v-model.trim="hotSpotData.name" class="form-control" id="hot-name">
        <button type="button" class="btn btn-secondary" @click="searchHotSpot">查询</button>
      </div>
      <div class="form-group">
        <label for="hot-title">所属场景标识</label>
        <input type="text" v-model.trim="hotSpotData.sceneTitle" class="form-control" id="hot-title">
      </div>
      <div class="form-group">
        <label for="hot-title-name">热点中文名称(鼠标悬浮时显示)</label>
        <input type="text" v-model.trim="hotSpotData.tipText" class="form-control" id="hot-title-name">
      </div>
      <div class="form-group">
        <label for="hot-title-name-en">热点英文名称(鼠标悬浮时显示)</label>
        <input type="text" v-model.trim="hotSpotData.tipTextEn" class="form-control" id="hot-title-name-en">
      </div>
      <div class="form-group">
        <label for="hot-type">热点类型</label>
        <select class="form-control" v-model="hotSpotData.type" id="hot-type">
          <option value="forward">前进路标</option>
          <option value="backward">后退路标</option>
          <option value="spotInfo">点击热区</option>
          <option value="spotSite">位置路标</option>
          <option value="spotInfoLink">点击外链</option>
        </select>
      </div>
      <div class="form-group">
        <label for="hot-h">h</label>
        <input type="number" v-model.number="hotSpotData.h" class="form-control" id="hot-h">
      </div>
      <div class="form-group">
        <label for="hot-v">v</label>
        <input type="number" v-model.number="hotSpotData.v" class="form-control" id="hot-v">
      </div>
      <div class="form-group">
        <label for="hot-to">连接到的场景(前进路标/位置路标有效)</label>
        <select class="form-control" v-model="hotSpotData.toScene" id="hot-to">
          <option v-for="scene of selectScenes" :key="scene" :value="scene">{{scene}}</option>
        </select>
      </div>
      <div class="form-group">
        <label for="hot-click">点击执行(点击热区有效)</label>
        <select class="form-control" v-model="hotSpotData.onClick" id="hot-click">
          <option value="popup_info">弹出详情(个人展)</option>
          <option value="popup_img">弹出图片</option>
          <option value="popup_poster">弹出海报</option>
          <option value="popup_video">弹出视频</option>
          <option value="popup_pdf">弹出pdf</option>
          <option value="popup_text">弹出文字内容</option>
          <option value="play_audio">播放音频</option>
          <option value="popup_bigMap">弹出电子地图</option>
        </select>
      </div>
      <div class="form-group">
        <label for="hot-data">点击执行参数(展位编号)</label>
        <input type="text" v-model="hotSpotData.clickData" class="form-control" id="hot-data">
      </div>
    </form>
    <!-- radar -->
    <form v-show="showItem === 'radar'">
      <div class="form-group">
        <label for="radar-name">雷达标识(英文)</label>
        <input type="text" v-model.trim="radarData.name" class="form-control" style="width: 80%; display: inline-block; margin-right: 10px;" id="radar-name">
        <button type="button" class="btn btn-secondary" @click="searchRadar">查询</button>
      </div>
      <div class="form-group">
        <label for="radar-title">所属场景标识</label>
        <input type="text" v-model.trim="radarData.sceneTitle" class="form-control" id="radar-title">
      </div>
      <div class="form-group">
        <label for="radar-h">x坐标</label>
        <input type="number" v-model.number="radarData.x" class="form-control" id="radar-h">
      </div>
      <div class="form-group">
        <label for="radar-v">y坐标</label>
        <input type="number" v-model.number="radarData.y" class="form-control" id="radar-v">
      </div>
      <div class="form-group">
        <label for="radar-heading">方向(0-360)</label>
        <input type="number" v-model.number="radarData.heading" class="form-control" id="radar-heading">
      </div>
    </form>
    <button class="btn btn-primary" @click="doSave">保存</button>
    <button v-if="showItem === 'scene'" type="button" class="btn btn-danger" @click="deleteScene">删除场景</button>
    <button class="btn btn-success" @click="doGenerate">生成配置文件</button>
  </div>
</template>

<script>
import axios from "axios"
export default {
  name: 'KrDesign',
  props: ['selectHotSpot', 'selectRadar'],
  data() {
    return {
      showItem: 'scene', // hotSpot radar
      sceneData: {
        "name": "",
        "title": "",
        "titleEn": "",
        "radar": "",
        "thumburl": "",
        "index": 0,
        "h": 0,
        "v": 0,
        "fov": 90,
        "preview": "",
        "img": "",
        "hotspot": []
      },
      hotSpotData: {
        "sceneTitle": "",// 所属的场景
        "name": "",
        "tipText": "",
        "tipTextEn": "",
        "h": 0,
        "v": 0,
        "type": "", // forward 路径 spotInfo 详情 spotSite 地点,
        "toScene": "",
        "onClick": "",
        "clickData": ""
      },
      radarData: {
        "sceneTitle": "",// 所属的场景
        "name": "",
        "heading": 0,
        "x": 0,
        "y": 0
      },
      selectImgs: [],
      selectScenes: [],
      hotList: []
    }
  },
  watch: {
    selectHotSpot: function (value) {
      if (value) {
        this.searchHotSpot(value)
      }
    },
    selectRadar: function (value) {
      if (value) {
        this.searchRadar(value)
      }
    }
  },
  mounted() {
    this.getSelectImgs()
    this.getAllSceneNames()
  },
  methods: {
    getSelectImgs() {
      axios.get('http://localhost:9099/api_design/sceneImgs').then((response) => {
        this.selectImgs = response.data.data || []
      })
    },
    getAllSceneNames() {
      axios.get('http://localhost:9099/api_design/allScenes').then((response) => {
        this.selectScenes = response.data.data || []
      })
    },
    doSelectHot(e, hotName) {
      if (e.target.checked && this.sceneData.hotspot.indexOf(hotName) < 0) {
        this.sceneData.hotspot.splice(this.sceneData.hotspot.length, 0, hotName)
      }
      if (!e.target.checked && this.sceneData.hotspot.indexOf(hotName) >= 0) {
        let index = this.sceneData.hotspot.indexOf(hotName)
        this.sceneData.hotspot.splice(index, 1)
      }
    },
    addNewScene() {
      this.hotList = []
      this.sceneData = {
        "name": "",
        "title": "",
        "titleEn": "",
        "radar": "",
        "thumburl": "",
        "index": 0,
        "h": 0,
        "v": 0,
        "fov": 90,
        "preview": "",
        "img": "",
        "hotspot": []
      }
      this.showItem = 'scene'
    },
    addNewHotSpot() {
      this.hotSpotData = {
        "sceneTitle": "",// 所属的场景
        "name": "",
        "tipText": "",
        "tipTextEn": "",
        "h": 0,
        "v": 0,
        "type": "", // forward 路径 spotInfo 详情 spotSite 地点,
        "toScene": "",
        "onClick": "",
        "clickData": ""
      },
        this.showItem = 'hotSpot'
    },
    addNewRadar() {
      this.radarData = {
        "sceneTitle": "",// 所属的场景
        "name": "",
        "heading": 0,
        "x": 0,
        "y": 0
      },
        this.showItem = 'radar'
    },
    queryScene() {
      this.showItem = 'scene'
      let sceneName = this.sceneData.name || ''
      sceneName && axios.get('http://localhost:9099/api_design/currentScene', { params: { sceneName: sceneName } }).then((response) => {
        let sceneData = response.data.data || {}
        if (sceneData.name) {
          sceneData.img += '.jpg'
          this.sceneData = sceneData
          this.hotList = sceneData.hotspot || []
        }
      })
    },
    getCurrentScene() {
      let sceneName = this.$route.query ? this.$route.query.scene : ''

      sceneName && axios.get('http://localhost:9099/api_design/currentScene', { params: { sceneName: sceneName } }).then((response) => {
        let sceneData = response.data.data || {}
        sceneData.img += '.jpg'
        this.sceneData = sceneData
        this.hotList = sceneData.hotspot || []
        this.showItem = 'scene'
      })
    },
    doSave() {
      if (this.showItem === 'scene') {
        this.saveSceneData()
      } else if (this.showItem === 'hotSpot') {
        this.saveHotSpotData()
      } else if (this.showItem === 'radar') {
        this.saveRadarData()
      }
    },
    deleteScene() {
      let name = this.sceneData.name
      name && axios.post('http://localhost:9099/api_design/deleteScene', { name: name }).then((response) => {
        if (response.data.status) {
          console.log('删除场景成功!')
        } else {
          console.log('删除场景失败!')
        }
        this.getAllSceneNames()
      })
    },
    saveSceneData() {
      axios.post('http://localhost:9099/api_design/addScene', this.sceneData).then((response) => {
        if (response.data.status) {
          console.log('新增场景成功!')
        } else {
          console.log('新增场景失败!')
        }
        this.getAllSceneNames()
      })
    },
    saveHotSpotData() {
      axios.post('http://localhost:9099/api_design/addHotspot', this.hotSpotData).then((response) => {
        if (response.data.status) {
          this.showNewHotSpot()
          console.log('新增热点成功!')
        } else {
          console.log('新增热点失败!')
        }
      })
    },
    showNewHotSpot() {
      let spName = this.hotSpotData.name
      window.krpano.call(`addhotspot(${spName})`,)
      let skin = './youth/kr_icon/forward1.gif'
      if (this.hotSpotData.type === 'forward') {
        skin = './youth/kr_icon/forward1.gif'
      } else if (this.hotSpotData.type === 'backward') {
        skin = './youth/kr_icon/backward.gif'
      } else if (this.hotSpotData.type === 'spotInfo') {
        skin = './youth/kr_icon/spot2.gif'
      } else if (this.hotSpotData.type === 'spotSite') {
        skin = './youth/kr_icon/site.gif'
      }else if(this.hotSpotData.type === 'spotInfoLink'){
        skin = './youth/kr_icon/spot2.gif'
      }
      window.krpano.set(`hotspot[${spName}].url`, skin)
      window.krpano.set(`hotspot[${spName}].ath`, this.hotSpotData.h)
      window.krpano.set(`hotspot[${spName}].atv`, this.hotSpotData.v)
      window.krpano.set(`hotspot[${spName}].renderer`, 'css3d')
      window.krpano.set(`hotspot[${spName}].scale`, '0.4')
      window.krpano.set(`hotspot[${spName}].style`, 'skin_tooltips')
      window.krpano.set(`hotspot[${spName}].distorted`, true)
    },
    saveRadarData() {
      let radarData = Object.assign({}, this.radarData)
      let x = radarData.x
      let y = radarData.y
      // let width = window.innerWidth
      // let height = window.innerHeight
      // let mapWidth = 3000
      // let mapHeight = 2426

      // radarData.x = x * (mapWidth / width)
      // radarData.y = y * (mapHeight / height)
      radarData.x = x
      radarData.y = y
      // 根据屏幕宽高和map图片原始尺寸进行变换
      axios.post('http://localhost:9099/api_design/addRadar', radarData).then((response) => {

        if (response.data.status) {
          console.log('新增雷达成功!')
        } else {
          console.log('新增雷达失败!')
        }
      })
    },
    searchHotSpot(hotSpotName) {
      let queryName = hotSpotName || this.hotSpotData.name
      this.showItem = 'hotSpot'
      if (queryName) {
        axios.get('http://localhost:9099/api_design/hotSpotDetail', { params: { name: queryName } }).then((response) => {
          if (response.data.status) {
            let resData = response.data.data || {}
            if (resData.name) {
              this.hotSpotData = resData
            }
          }
        })
      }
    },
    searchRadar(radarName) {
      let queryName = radarName || this.hotSpotData.name
      this.showItem = 'radar'
      if (queryName) {
        axios.get('http://localhost:9099/api_design/radarDetail', { params: { name: queryName } }).then((response) => {
          if (response.data.status) {
            let resData = response.data.data || {}
            if (resData.name) {
              this.radarData = resData
            }
          }
        })
      }
    },
    doGenerate() {
      axios.post('http://localhost:9099/api_design/generateView').then((response) => {
        if (response.data.status) {
          console.log('生成配置文件成功!')
        } else {
          console.log('生成配置文件失败!')
        }
      })
    }
  }
}
</script>

<style scoped>
.design-wrapper {
  position: fixed;
  top: 50px;
  left: 0px;
  width: 350px;
  z-index: 100;
  padding: 10px 20px;
  max-height: 600px;
  overflow: scroll;
  background-color: rgba(0, 0, 0, 0.6);
}
.btn {
  margin-right: 10px;
}
.form-group label {
  color: #ffffff;
}
.form-group select {
  height: 32px;
}
.btn-success {
  margin-left: 50px;
}
</style>